import React from 'react';
import { Alert, Box } from '@zillow/constellation-10';

import { format } from 'date-fns';
import { useAppMaintenance } from '../hooks/useMaintenance';

const timeFormat = 'MM/dd/yy hh:mm aa';

const BillingPortalMaintenanceBanner = () => {
  const { billingPortalMaintenance, billingPortalMaintenanceChecked, isMaintenanceMode } = useAppMaintenance();

  if (
    !billingPortalMaintenanceChecked ||
    !billingPortalMaintenance ||
    !billingPortalMaintenance.left ||
    !billingPortalMaintenance.right
  ) {
    return null;
  }

  const startTime = format(new Date(billingPortalMaintenance.left.seconds * 1000), timeFormat);
  const endTime = format(new Date(billingPortalMaintenance.right.seconds * 1000), timeFormat);

  return (
    <Box css={{ marginBottom: 'md' }}>
      <Alert tone={isMaintenanceMode ? 'critical' : 'warning'}>
        {`Billing Portal ${
          isMaintenanceMode ? 'is currently' : 'will be'
        } unavailable between ${startTime} and ${endTime}`}
      </Alert>
    </Box>
  );
};

export default BillingPortalMaintenanceBanner;
